module.exports = "<div class=\"sn-header not-print\" ng-show=\"navbar && !$root.isContactForm\" style=\"height: auto\">\n    <notification-bar ng-if=\"navbar === 'authenticatedUser'\"></notification-bar>\n    <div class=\"mobile-banner-styles header-container\">\n        <user-navbar ng-if=\"navbar === 'authenticatedUser'\"></user-navbar>\n        <anonymous-navbar ng-if=\"navbar === 'anonymousUser'\"></anonymous-navbar>\n        <admin-navbar ng-if=\"navbar === 'adminUser'\"></admin-navbar>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./web/js/components/navigation/header/header.component.html
// module id = ./web/js/components/navigation/header/header.component.html
// module chunks = 0